import React from "react"
import { AppBasicTable } from "@components"
import {
	analyzersColumn,
	checkerColumn,
	dateColumn,
	downloadColumn,
	globalDownloadColumn,
	statusColumn
} from "Pages/ReportsAlerts/Reports/@components/InfoModal/Content/History/Table/columns"


export default function ReportListHistoricalModalContentTable({ reportName, data, officeSelected }) {

	return <AppBasicTable
		sx={{ maxHeight: 400, borderRadius: 1 }}
		title={`${reportName}'s Executions`}
		toolbarProps={{ actions: false }}
		data={data}
		headers={[[
			{ label: 'Date' },
			{ label: 'Status' },
			{ label: 'Exported' },
			{ label: 'Mailed' },
			{ label: 'Opened' },
			{ label: 'Links' },
			{ label: 'Download' },
			{ label: 'Global Download' },
		]]}
		columns={[
			dateColumn(),
			statusColumn(),
			checkerColumn('exported'),
			checkerColumn('mailed'),
			checkerColumn('opened'),
			analyzersColumn(officeSelected),
			downloadColumn(),
			globalDownloadColumn(),
		]}
	/>
}